var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftPanelProperty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "colorable",
    fill: "rgba(0,0,0,0.87)",
    d: "M15.97 17h-2.006c.023-.326.035-.662.035-1a14.012 14.012 0 0 0-1.657-6.621 3.009 3.009 0 0 0 1.632-1.185A15.99 15.99 0 0 1 16 16c0 .338-.01.674-.031 1zM8.828 5.132A13.814 13.814 0 0 0 0 2V0a15.98 15.98 0 0 1 5.5.965 15.861 15.861 0 0 1 4.8 2.786 3.014 3.014 0 0 0-1.467 1.38z",
    opacity: 0.3,
    transform: "translate(3 3.001)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "colorable",
    cx: 3,
    cy: 3,
    r: 3,
    fill: "rgba(0,0,0,0.87)",
    transform: "translate(10.5 5.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPanelProperty);
export default __webpack_public_path__ + "static/media/left-panel-property.c3eca52fd5766f62a10b53c0c2308580.svg";
export { ForwardRef as ReactComponent };